import { useNavigate } from "react-router-dom";

export function BrandLogo({ className = "h-8", testId = "brand-logo" }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate("/")}
      aria-label="Go to CareerStudy360 home page"
      data-testid="brand-logo-home-button"
      className="inline-flex items-center cursor-pointer"
    >
      <img
        src="/branding/CS360-01.webp"
        alt="CareerStudy360"
        data-testid={testId}
        className={`${className} w-auto object-contain`}
      />
    </button>
  );
}
